import React from 'react';
import PropTypes from 'prop-types';

import { BoxLink } from 'components/Common';

const FaqQuestions = ({ faqCategories }) => (
  <div className="row">
    {faqCategories.map(faqCategory => (
      <div className="columns small-12 medium-12 large-6" key={faqCategory.id}>
        <h4>{faqCategory.title}</h4>

        <BoxLink.Container>
          {faqCategory.questions.map(question => (
            <BoxLink
              key={question.id}
              title={question.question}
              small
              to={`/help/${question.id}`}
            />
          ))}
        </BoxLink.Container>
      </div>
    ))}
  </div>
);

FaqQuestions.propTypes = {
  faqCategories: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default FaqQuestions;



// WEBPACK FOOTER //
// ./src/components/FaqQuestions/FaqQuestions.js